inputs-checkbox-select
  div(class="form-group row { error: opts.errors }")
    label.col-md-4.col-form-label
      | {opts.label}
      span.text-danger(if="{ opts.required }") &nbsp;*
    .col-md-8
      span(each="{item, namespace in opts.items}")
        .checkbox-fade.fade-in-primary
          label
            input(type="checkbox" value="{ item.value }" name="{ item.name }" onClick="{ this.onChange }" data-id="{item.namespace}" checked="{item.checked}")
            span.cr
              i.cr-icon.icofont.icofont-ui-check.txt-primary
            span { item.label }
      div.help-block(if="{ opts.errors }")
        ul(role="alert")
          li.text-danger.error(each="{message in opts.errors}") { message }
  script(type="typescript").
    this.mixin('inputs.checkbox-select');
